import { Toast, type ToastType } from "@legal-500/legal500-design-system";
import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { gatewayRoutesService } from "../../api/gatewayRoutes.service";
import { PageHeader } from "../../components/PageHeader";
import { UnauthorizedView } from "../../components/UnauthorizedView";
import styles from "./GatewayAllowlist.module.css";

function GatewayAllowlistLayout() {
  const [authError, setAuthError] = useState<Error | null>(null);
  const [toast, setToast] = useState<{ message: string; type: ToastType } | null>(null);
  const [refetchTrigger, setRefetchTrigger] = useState(0);

  useEffect(() => {
    async function checkAuth() {
      try {
        await gatewayRoutesService.getAll();
      } catch (err) {
        const error = err instanceof Error ? err : new Error("Failed to check auth");
        const status = (error as Error & { status?: number }).status;
        if (status === 401 || status === 403) {
          setAuthError(error);
        }
      }
    }
    checkAuth();
  }, []);

  function handleCloseToast() {
    setToast(null);
  }

  function handleMutationSuccess() {
    setRefetchTrigger(prev => prev + 1);
  }

  if (authError) {
    return <UnauthorizedView />;
  }

  return (
    <div className={styles.wrapper}>
      <div>
        <PageHeader
          title="Gateway Allowlist"
          subtitle="Manage which service routes are exposed through the integration gateway"
        />
      </div>

      <Outlet
        context={{
          toast,
          setToast,
          refetchTrigger,
          onMutationSuccess: handleMutationSuccess,
        }}
      />

      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={handleCloseToast}
          duration={5000}
        />
      )}
    </div>
  );
}

export default GatewayAllowlistLayout;
